import { EwaThunk } from "../types";
import {
  getIsDataSourcesFetching,
  getIsDataSourceStateFetchingForId,
  getIsStateFetching,
} from "./selectors";
import {
  isDataSourcesFetching,
  isDataSourcesStateFetching,
  isDataSourceStateFetching,
  receiveDataSources,
  receiveDataSourcesState,
  updateDataSourceState,
} from "./actionCreators";
import {
  fetchDataSourceById,
  fetchDataSources,
  fetchDataSourcesStates,
  fetchDataSourceStateById,
} from "../../requests/dataSources/requestCreators";
import flowioast from "../../utils/flowioast";

export const fetchDataSourcesThunk = (): EwaThunk => (dispatch, getState) => {
  const state = getState();
  const isFetching = getIsDataSourcesFetching(state);

  if (isFetching) return;

  dispatch(isDataSourcesFetching({ flag: true }));

  fetchDataSources()
    .then((response) => {
      const { data } = response;
      dispatch(receiveDataSources({ dataSources: data }));
    })
    .catch((e) => flowioast.error.fromIntlBase("datasource.fetch.plural", e))
    .finally(() => dispatch(isDataSourcesFetching({ flag: false })));
};

export const fetchDataSourcesStateThunk =
  (idsOfDataSources?: number[]): EwaThunk =>
  (dispatch, getState) => {
    const state = getState();
    const isFetching = getIsStateFetching(state);

    if (isFetching) return;

    dispatch(isDataSourcesStateFetching({ flag: true }));

    fetchDataSourcesStates(idsOfDataSources || [])
      .then((response) => {
        const { data } = response;
        dispatch(receiveDataSourcesState({ dataSourcesState: data }));
      })
      .catch((e) =>
        flowioast.error.fromIntlBase("datasource.fetch.singular", e)
      )
      .finally(() => dispatch(isDataSourcesStateFetching({ flag: false })));
  };

export const fetchDataSourceStateByIdThunk =
  (dataSourceId: number): EwaThunk =>
  (dispatch, getState) => {
    const state = getState();
    const isFetching = getIsDataSourceStateFetchingForId(state, dataSourceId);

    if (isFetching) return;

    dispatch(isDataSourceStateFetching({ dataSourceId, flag: true }));

    fetchDataSourceStateById(Number(dataSourceId))
      .then((response) => {
        const { data } = response;
        dispatch(
          updateDataSourceState({ dataSourceId, dataSourceState: data })
        );
      })
      .catch((e) =>
        flowioast.error.fromIntlBase("datasource.fetch.singular", e)
      )
      .finally(() =>
        dispatch(isDataSourceStateFetching({ dataSourceId, flag: false }))
      );
  };
